import { Inn, InnPage } from "../dtos";
import { BaseEndpoint } from "./BaseEndpoint";
import { WithSearchableGetPage } from "./mixins/WithSearchableGetPage";

export class Endpoint extends BaseEndpoint("inns") {}

export const InnEndpoint = WithSearchableGetPage<typeof Endpoint, Inn, InnPage>(Endpoint);
